import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ImageGallery } from '../../components';
import serviceImages from '../../services/imagenes';
import { FormTabsArticulo } from '../../components/FormArticulo';
import MovementsService from '../../services/movements';
import ArticleService from '../../services/articulos';
import { TYPE_MOVEMENT } from '../../helpers/enums';

const Recuperar = ({ store }) => {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [articleSelected, setArticleSelected] = useState({});
  const [openAddingArticle, setOpenAddingArticle] = useState(false);
  const [saving, setSaving] = useState(false);
  const [investment, setInvestment] = useState(0);

  const loadImages = async () => {
    setLoading(true)
    var imgs = await serviceImages.getAll()
    setImages(imgs)
    getMovementsDineroDisponible()
    setLoading(false)
  }

  useEffect(() => {
    loadImages()
  }, []);

  const handleConfirmSelection = (imagesSelected) => {
    setOpenAddingArticle(true)
    setArticleSelected({
      article: {
        images: imagesSelected
      }
    })
  }

  const getMovementsDineroDisponible = async () => {
    if (store) {
      var resp = await MovementsService.searchMovements(store._id, `type=${TYPE_MOVEMENT.DINERO_DISPONIBLE}`)
      //var aux = resp?.length > 0 && resp[0].amount > 0
      resp && setInvestment(resp[0].amount)
    }
  }

  const saveArticle = async (data) => {
    setSaving(true)
    data.store_id = store._id
    if (data) {
      await ArticleService.saveArticleInStore(store._id, data)
      //set(true)
    }
    setSaving(false)
    setOpenAddingArticle(false)
  }

  return <Box display='flex' minHeight='100%' maxWidth='100%'>
    {!openAddingArticle && <Box>
      <h1> Imagenes</h1>
      <ImageGallery loading={loading} images={images} onConfirmSelection={handleConfirmSelection} />
    </Box>
    }
    {openAddingArticle && <FormTabsArticulo
      articleData={articleSelected}
      onSubmit={saveArticle}
      investmentAmount={investment}
      onCancel={() => { setOpenAddingArticle(false); setArticleSelected(null) }}
      saving={saving}
      //articles={articulos}
      storeId={store._id}
      uploadImage={false}
    />}
  </Box>
}

export default Recuperar;